import Reveal from "@/components/base/Reveal";
import { REGIONS } from "@/constants/site";

const ITEMS = [
  {
    icon: "ri-search-eye-line",
    title: "Avaliação técnica",
    description: "Diagnóstico para identificar a causa e definir a solução adequada.",
  },
  {
    icon: "ri-tools-line",
    title: "Processo eletromecânico",
    description: "Manutenção e recuperação com procedimentos técnicos aplicáveis.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Atendimento regional",
    description: "Sul, Sudeste e Centro-Oeste do Brasil.",
  },
  {
    icon: "ri-team-line",
    title: "Relacionamento B2B",
    description: "Foco em indústrias e empresas que não podem parar.",
  },
];

export default function Authority() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <h2 className="text-center font-heading text-3xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            Por que a indústria confia na Power
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((item, i) => (
            <Reveal key={item.title} delay={i * 70}>
              <div className="h-full rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {item.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
            {REGIONS.map((r) => (
              <span
                key={r}
                className="rounded-full border border-background-300 bg-background-50 px-4 py-1.5 text-sm font-semibold text-foreground-700"
              >
                {r}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}